import { Component, type ReactNode } from 'react';

type Props = {
	elementToAlignSelector: string;
	alignWithSelector: string;
	children: ReactNode;
};

/**
 * Use to align one `position: sticky` element to the bottom of another (if they are not siblings),
 * so that both sticky elements can be shown on the page atthe same time
 */
// eslint-disable-next-line jira/react/no-class-components
export class StickyElementAligner extends Component<Props> {
	componentDidMount(): void {
		this.align();

		// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
		window.addEventListener('resize', this.align);
	}

	componentWillUnmount(): void {
		// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
		window.removeEventListener('resize', this.align);
	}

	elementToAlign: HTMLElement | null = null;

	alignWithElement: HTMLElement | null = null;

	// eslint-disable-next-line jira/react-arrow-function-property-naming
	align = () => {
		const { alignWithSelector, elementToAlignSelector } = this.props;

		// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
		this.alignWithElement = this.alignWithElement || document.querySelector(alignWithSelector);

		// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
		this.elementToAlign = this.elementToAlign || document.querySelector(elementToAlignSelector);

		if (!this.alignWithElement || !this.elementToAlign) {
			return;
		}

		// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
		const alignWithElementStyle = window.getComputedStyle(this.alignWithElement);

		if (alignWithElementStyle.position !== 'sticky') return;

		const alignWithElementTop = parseInt(alignWithElementStyle.top, 10);

		this.elementToAlign.style.top = `${this.alignWithElement.offsetHeight + alignWithElementTop}px`;
	};

	render() {
		return this.props.children;
	}
}
